import { render } from "./payment-method-card.vue?vue&type=template&id=24a8201a&scoped=true"
import script from "./payment-method-card.vue?vue&type=script&lang=js"
export * from "./payment-method-card.vue?vue&type=script&lang=js"

import "./payment-method-card.vue?vue&type=style&index=0&id=24a8201a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a8201a"]])

export default __exports__